module.exports = __webpack_public_path__ + "static/media/spectrum.62f5da09.webp";